import React, { useEffect, useState } from "react";
import {
  getClientes,
  putClientes,
  postClientes,
} from "../../componentes/http/actions/ClientesAction";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  Button,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FilterComponent from "../../componentes/data/FilterComponent";
import EditarClienteModal from "../../componentes/modal/Clientes/EditarClienteModal";
import NuevoClienteModal from "../../componentes/modal/Clientes/NuevoClienteModal";

const GestorClientes = () => {
  const [cliente, setCliente] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchClientes();
  }, []);

  const fetchClientes = () => {
    setIsLoading(true);
    getClientes(localStorage.getItem("token"))
      .then((response) => {
        setCliente(Array.isArray(response) ? response : []);
      })
      .catch((error) => {
        console.log(error);
        setCliente([]);
        setSnackbar({
          open: true,
          message: "Error al cargar clientes",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };
  
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenEditModal = (cliente) => {
    setClienteSeleccionado(cliente);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setClienteSeleccionado(null);
  };

  const filteredCliente = cliente
    .filter((clasificacion) => {
      const matchesSearch = clasificacion.nombre
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" &&
          clasificacion.habilitado === true) ||
        (filterHabilitado === "deshabilitado" &&
          clasificacion.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0);
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0);
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const handleEditarCliente = async (editado) => {
    try {
      setIsLoading(true);
      await putClientes(localStorage.getItem("token"), editado);
      await fetchClientes();
      handleCloseEditModal();
      setSnackbar({
        open: true,
        message: "Cliente editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar Cliente:", error);
      setSnackbar({
        open: true,
        message: "Error al editar Cliente",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleNuevoCliente = async (nuevo) => {
    try {
      setIsLoading(true);
      await postClientes(localStorage.getItem("token"), nuevo);
      await fetchClientes();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Cliente agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nuevo Cliente:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar Cliente",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Clientes</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir Cliente
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        <TableContainer component={Paper}>
          {isLoading && !initialDataLoaded ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : filteredCliente.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Id</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Habilitado</TableCell>
                  <TableCell
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredCliente.map((cliente, index) => (
                  <TableRow key={index}>
                    <TableCell>{cliente.id}</TableCell>
                    <TableCell>{cliente.nombre}</TableCell>
                    <TableCell>
                      <Chip
                        label={cliente.habilitado ? "Sí" : "No"}
                        color={cliente.habilitado ? "success" : "error"}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                        <Tooltip title="Editar cliente">
                          <Button
                            color="primary"
                            onClick={() => handleOpenEditModal(cliente)}
                            size="small"
                          >
                            <EditNoteIcon />
                          </Button>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Box p={3}>
              <Typography>
                No se encontraron clientes con los criterios de búsqueda actuales.
              </Typography>
            </Box>
          )}
        </TableContainer>
        <TablePagination
          component="div"
          count={cliente
            .filter((clasificacion) => {
              const matchesSearch = clasificacion.nombre
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
              const matchesFilter =
                filterHabilitado === "todos" ||
                (filterHabilitado === "habilitado" &&
                  clasificacion.habilitado === true) ||
                (filterHabilitado === "deshabilitado" &&
                  clasificacion.habilitado === false);
              return matchesSearch && matchesFilter;
            }).length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
        />
      </Grid>
      <NuevoClienteModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoCliente}
      />
      <EditarClienteModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        cliente={clienteSeleccionado}
        onSubmit={handleEditarCliente}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorClientes;